import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M16.3645 6.38672C16.6819 6.38672 16.9862 6.51245 17.2106 6.73625C17.435 6.96005 17.5611 7.2636 17.5611 7.5801C17.5611 7.8966 17.435 8.20014 17.2106 8.42395C16.9862 8.64775 16.6819 8.77348 16.3645 8.77348C16.0472 8.77348 15.7428 8.64775 15.5184 8.42395C15.294 8.20014 15.168 7.8966 15.168 7.5801C15.168 7.2636 15.294 6.96005 15.5184 6.73625C15.7428 6.51245 16.0472 6.38672 16.3645 6.38672Z",
      stroke: "#5A5A5A",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M4.61733 11.2744C3.81724 12.1655 3.80049 13.51 4.53437 14.4568C5.95986 16.3024 7.61844 17.9566 9.46892 19.3783C10.4182 20.1102 11.7663 20.0935 12.6597 19.2956C15.0748 17.141 17.3442 14.8293 19.4529 12.3755C19.6658 12.1315 19.7969 11.8272 19.8278 11.5052C19.9586 10.0763 20.2291 5.95992 19.1083 4.84292C17.9875 3.72591 13.861 3.99482 12.4284 4.12609C12.1055 4.15694 11.8004 4.28768 11.5557 4.50002C9.0955 6.60293 6.77764 8.86602 4.61733 11.2744Z",
      stroke: "#5A5A5A",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M13.4045 12.2478C13.422 11.928 13.5113 11.3448 13.0248 10.9009M13.0248 10.9009C12.8391 10.74 12.6229 10.618 12.389 10.5421C11.3863 10.1896 10.1554 11.3687 11.0265 12.4483C11.4948 13.0291 11.8561 13.2073 11.821 13.866C11.7971 14.3291 11.3408 14.8136 10.7394 14.9982C10.2169 15.1589 9.64012 14.9464 9.27558 14.5399C8.82966 14.0434 8.87513 13.5756 8.87114 13.372M13.0248 10.9009L13.5736 10.3535M9.31387 14.602L8.79297 15.1215",
      stroke: "#5A5A5A",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }